<template>
    <div v-if="fan && displayTables" class="baf-container-main">
        <div v-for="table in tables">
            <div class="baf-tables">
                <h2>{{table.title}}</h2>
                <div class="baf-container">
                    <div class="baf-first-col">
                        <div class="baf-header">{{translate(table.main.title)}}</div>
                        <span class="baf-number">{{table.main.value}}</span>
                    </div>
                    <div class="baf-second-col">
                        <span class="baf-header">{{translate(table.params.title)}}</span>
                        <div class="baf-params" v-for="element in table.params.params">
                    <span class="baf-desc"
                          :class="{desc_cell: element.unit == undefined}" v-html="translate(element.code)"></span>
                            <span class="baf-value"
                                  :class="{merge_cell: element.unit == undefined}">

                            <template v-if="element.translation">{{translate(element.value)}}</template>
                            <template v-else>{{element.value}}</template>
                        </span>
                            <span class="baf-unit" :class="{empty_cell: element.unit == undefined}"
                                  v-html="element.unit"></span>
                        </div>
                    </div>
                </div>
            </div>
            <p class="bafa-warning-comment">
                {{(workOnInverter==='yes')?translate('bafa_warning_inverter_comment'):''}}</p>
        </div>
        <div class="navi-btn">
            <span @click="goBack" class="back-btn circle-btn"></span>
            <button class="pdf-btn" @click="generatePDF">
                <InlineLoader v-if="pdfInAction"/>
                <template v-else>
                    {{translate("print_to_pdf")}}
                </template>
            </button>
        </div>
    </div>
</template>

<script>
    import {Calculator} from "../calculator";
    import {measurementShow} from "../measurementShow";
    import {unit} from "../unit";
    import InlineLoader from "../components/InlineLoader";
    import ErpBafa from "../erpBafa";

    export default {
        name: "BafTables",
        components: {InlineLoader},
        data() {
            return {
                savedFourthStepParametersSelectedWorkPointFrequency: {},
                savedFourthStepParametersSelectedWorkFrequency: {},
                savedSelectedFan: {},
                savedNetworkFrequency: 0,
                unwatch: function () {
                },
                fanCount: 1,
                pdfInAction: false,
                searchQuery: '',
                fan: {},
                frequency: '',
                workFrequency: '',
                workOnInverter: 'no',
                staticPoint: false,
                displayTables: false,
                measurement: {},
                tables: {
                }
            }
        },
        created() {

            if (!this.$store.state.fourthStepParametersSelected || !this.$store.state.fourthStepParametersSelected.workPointAirDensityCalced) {
                this.$store.state.fourthStepParametersSelected = JSON.parse(JSON.stringify(this.$store.state.fourthStepParameters));
            }


            let unitObj = null;

            if (window.unitsList) {

                for (let parameter in window.unitsList) {
                    if (window.unitsList.hasOwnProperty(parameter)
                        && window.unitsList[parameter].hasOwnProperty('list')
                        && window.unitsList[parameter].list.length > 0) {
                        unitObj = window.unitsList[parameter].list[0];
                        break;
                    }
                }

                if (this.$store.state.fourthStepParametersSelected && this.$store.state.fourthStepParametersSelected.workPointAirDensityCalced && unitObj && typeof unitObj.apply !== 'function') {
                    this.$store.commit({
                        type: 'cleanParamsValue'
                    });

                    this.measurement = measurementShow;
                    this.measurement.init(this.$store);
                    this.measurement.refreshAxis();
                    this.measurement.refreshAllData(parseInt(this.frequency));
                }
            }


            this.unwatch = this.$store.watch(state => state.bafaSearchActive,
                (value, oldValue) => {
                    this.prefetchBafaData();
                });
            this.prefetchBafaData();

        },
        beforeDestroy() {
            this.unwatch();
            delete this.measurement;
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },

            getRandomNumber(min, max) {
                return Math.random() * (max - min) + min;
            },

            generatePDF() {
                if (this.pdfInAction) return;
                this.pdfInAction = true;
                let content = document.body.outerHTML;
                let data = new FormData();
                data.append('content', content);
                data.append('id_offer_temp', `bafa_tables_${this.getRandomNumber(10000000, 99999999)}`);
                this.$apiController.getSinglePdf(data)
                    .then((res) => {
                        if (res.status === 'success') {
                            const linkSource = `data:application/pdf;base64,${res.data.file}`;
                            const downloadLink = document.createElement("a");
                            let fileName = `${this.tables.bafaTable.main.value.replace(/\//gi, '-')}_ERP_BAFA.pdf`;

                            downloadLink.href = linkSource;
                            downloadLink.download = fileName;
                            downloadLink.click();
                            this.$notifications.add(this.$notifications.TYPES.NOTIFICATION, 'PDF', this.translate('pdf_generate_success'));
                        } else {
                            this.$notifications.add(this.$notifications.TYPES.ERROR, 'PDF', this.translate('pdf_generate_fail'));
                        }
                    })
                    .catch((e) => {
                        this.$notifications.add(this.$notifications.TYPES.ERROR, 'PDF', this.translate('pdf_generate_fail'));
                    }).finally(() => {
                    this.pdfInAction = false;
                });

            },
            prefetchBafaData() {
                let searchQuery = this.$store.state.bafaSearchQuery;
                this.searchQuery = searchQuery;
                let form = new FormData();
                form.append('type_number', searchQuery);
                this.$apiController.getFanByTypeNumber(form)
                    .then((res) => {

                        if (res.status === 'success') {
                            this.fan = res.data;
                            this.$store.state.selectedFan = this.fan;
                            this.calcBafaErp(res.data);
                        } else if (res.status === 'error') {
                            this.$notifications.add(this.$notifications.TYPES.WARNING, 'BAFA / ERP', this.translate(res.message))
                        }

                    });

                this.$store.state.fourthStepParametersSelected = this.$store.state.fourthStepParameters;
            },

            calcBafaErp(data) {
                let selectedParameters = this.$store.state.bafaParameters;
                for (let option in selectedParameters.network_frequency.options[0].elements) {
                    if (selectedParameters.network_frequency.options[0].elements.hasOwnProperty(option)) {
                        if (selectedParameters.network_frequency.options[0].elements[option].active) {
                            this.frequency = selectedParameters.network_frequency.options[0].elements[option].value;
                        }
                    }
                }

                this.workFrequency = selectedParameters.work_frequency.options[0].value;

                for (let option in selectedParameters.work_on_the_inverter.options[0].elements) {
                    if (selectedParameters.work_on_the_inverter.options[0].elements.hasOwnProperty(option)) {
                        if (selectedParameters.work_on_the_inverter.options[0].elements[option].active) {
                            this.workOnInverter = selectedParameters.work_on_the_inverter.options[0].elements[option].value;
                        }
                    }
                }

                let savedFourthStepParametersSelected = JSON.parse(JSON.stringify(this.$store.state.fourthStepParametersSelected));

                for (let elementId in this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements) {

                    if (this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements.hasOwnProperty(elementId)) {

                        if (this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements[elementId].active) {
                            this.savedNetworkFrequency = this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements[elementId].value;
                        }

                        if (this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements[elementId].value === this.frequency)
                            Vue.set(this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements[elementId], 'active', true);
                        else
                            Vue.set(this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements[elementId], 'active', false);

                    }
                }

                this.savedSelectedFan = this.$store.state.selectedFan;
                this.savedFourthStepParametersSelectedWorkPointFrequency = this.$store.state.fourthStepParametersSelected['workPointFrequency'].value;

                this.$store.state.fourthStepParametersSelected['workPointFrequency'].value = this.frequency;

                this.fanCount = this.$store.state.activeFun.count;

                this.$store.state.activeFun.count = 1;

                let bafaCalculator = new ErpBafa(this.$store, this.workOnInverter, this.frequency, this.workFrequency, this.fan, this.$calculator, false);

                bafaCalculator.resetTablesValues();

                this.tables = bafaCalculator.calculate();

                this.displayTables = true;

                this.$store.state.fourthStepParametersSelected['workPointFrequency'].value = this.savedFourthStepParametersSelectedWorkPointFrequency;
                this.$store.state.activeFun.count = this.fanCount;
                this.$store.state.selectedFan = this.savedSelectedFan;

                for (let elementId in this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements) {
                    if (this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements.hasOwnProperty(elementId)) {

                        if (this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements[elementId].value === this.savedNetworkFrequency)
                            Vue.set(this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements[elementId], 'active', true);
                        else
                            Vue.set(this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements[elementId], 'active', false);
                    }
                }

                this.$store.state.fourthStepParametersSelected = savedFourthStepParametersSelected;

            },

            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },
        }
    }
</script>

<style scoped>

</style>
